"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _TopAreaNavigation = require("./TopAreaNavigation");
Object.keys(_TopAreaNavigation).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TopAreaNavigation[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _TopAreaNavigation[key];
    }
  });
});
